let promotion = [
  {
    path: 'group',
    meta: {
      title: '福利号活动',
      breadcrumb: true
    },
    component: {
      name: 'group',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '/',
        meta: {
          title: '福利号活动',
        },
        component: (resolve) => require(['@/views/plat/promotion/group'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/promotion/group/children/newAdd'], resolve)
      },
      {
        path: 'editor',
        meta: {
          title: "编辑",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/promotion/group/children/editor'], resolve)
      },
      {
        path: 'attachment/editImage',
        meta: {
          title: "编辑附件",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/promotion/group/children/attachment/editImage'], resolve)
      },
	  {
	    path: 'attachment/editGenie',
	    meta: {
	      title: "编辑附件",
	      breadcrumb: true,
	    },
	    component: (resolve) => require(['@/views/plat/promotion/group/children/attachment/editGenie'], resolve)
	  },
	  {
	    path: 'attachment/editMiniApp',
	    meta: {
	      title: "编辑附件",
	      breadcrumb: true,
	    },
	    component: (resolve) => require(['@/views/plat/promotion/group/children/attachment/editMiniApp'], resolve)
	  },
      {
        path: 'attachment/createMiniApp',
        meta: {
          title: "新建附件",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/promotion/group/children/attachment/createMiniApp'], resolve)
      },
	  {
	    path: 'attachment/createImage',
	    meta: {
	      title: "新建附件",
	      breadcrumb: true,
	    },
	    component: (resolve) => require(['@/views/plat/promotion/group/children/attachment/createImage'], resolve)
	  },
	  {
	    path: 'attachment/createGenie',
	    meta: {
	      title: "新建附件",
	      breadcrumb: true,
	    },
	    component: (resolve) => require(['@/views/plat/promotion/group/children/attachment/createGenie'], resolve)
	  },
      {
        path: 'attachment',
        meta: {
          title: "活动附件",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/promotion/group/children/attachment/index'], resolve)
      }
    ]
  },
  {
    path: 'friend',
    meta: {
      title: '朋友圈活动',
      breadcrumb: true
    },
    component: {
      name: 'friend',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '/',
        meta: {
          title: '朋友圈活动',
        },
        component: (resolve) => require(['@/views/plat/promotion/friend'], resolve)
      },
      {
        path: 'newAdd',
        meta: {
          title: "新增",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/promotion/friend/children/newAdd'], resolve)
      },
      {
        path: 'editor',
        meta: {
          title: "编辑",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/promotion/friend/children/editor'], resolve)
      },
      {
        path: 'attachment/editImage',
        meta: {
          title: "编辑附件",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/promotion/friend/children/attachment/editImage'], resolve)
      },
      {
        path: 'attachment/createImage',
        meta: {
          title: "新建附件",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/promotion/friend/children/attachment/createImage'], resolve)
      },
      {
        path: 'attachment',
        meta: {
          title: "活动附件",
          breadcrumb: true,
        },
        component: (resolve) => require(['@/views/plat/promotion/friend/children/attachment/index'], resolve)
		}
	]
	}
]

export default {
  path: '/promotion',
  redirect: '/promotion/promotion',
  meta: {
      title: "私域运营",
      breadcrumb: true
  },
  component: {
      name: 'promotion',
      template: '<router-view></router-view>'
  },
  children: promotion
}


// WEBPACK FOOTER //
// ./src/router/promotion.js